import { defineFcm } from '../shared/factory';

export const FCM_ENDORSEMENTS_PETITION_PAGE = defineFcm('endorsements_petition_page')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition details',
		description: 'FC to hide or show the endorsements section on the petition page while development',
		import: false,
	});
